import { Select } from 'antd';
import React from 'react';

import DefaultFormItem from 'components/composites/DefaultFormItem';
import { CountryAbbreviation } from 'types/models/country';
import { useTimezonesForCountry } from 'utils/use-timezones';

const LABEL = 'Time Zone';

interface Props {
  formItemName: string | string[];
  readOnly?: boolean;
  countryAbbreviation: CountryAbbreviation;
}

function FormItemTimezone({
  formItemName,
  readOnly,
  countryAbbreviation
}: Props): JSX.Element {
  const timezones = useTimezonesForCountry(countryAbbreviation);

  const timezoneOptions = timezones.map((timezone) => ({
    label: timezone,
    value: timezone
  }));

  return (
    <DefaultFormItem
      name={formItemName}
      label={LABEL}
      readOnly={readOnly}
      rules={[
        {
          required: true,
          message: 'Please enter a time zone'
        }
      ]}
    >
      <Select showSearch placeholder="Time Zone" options={timezoneOptions} />
    </DefaultFormItem>
  );
}

export default FormItemTimezone;
